import React, { useState } from "react"
import NextImg from "@/common/components/NextImg"
import styled from "styled-components"
import ABlock from "./ABlock"
import BBlock from "./BBlock"
import CBlock from "./CBlock"
import Panel from "./Panel"
import CircleBG from "@/containers/MoneyFortune/View/completeQA/CircleBG"

export default function ResultCard({
  name,
  roleID,
  peopleName,
  AKA,
  chance,
  saying,
  summary,
  analysis,
  investment,
  befit,
  img,
  type,
  resultImg,
  reset,
  API,
  GetAndShare,
  phone,
  setPhone,
  setAnswerInfoHandler,
  saveAnswerInfoToAPI,
  getTraitId
}) {
  const [showPanel, setShowPanel] = useState("close")
  const [panelContent, setPanelContent] = useState()

  return (
    <BG>
      <BGWrapper>
        <NextImg src={img} />
        <div className="filter"></div>
      </BGWrapper>
      <CircleWrapper>
        <CircleBG />
      </CircleWrapper>
      <Wrapper>
        <ABlockWrapper>
          <ABlock
            img={img}
            name={name}
            chance={chance}
            investment={investment}
            saying={saying}
            peopleName={peopleName}
          />
        </ABlockWrapper>
        <BBlockWrapper>
          <BBlock
            img={img}
            setShowPanel={setShowPanel}
            setPanelContent={setPanelContent}
            roleID={roleID}
            type={type}
            reset={reset}
            resultImg={resultImg}
            API={GetAndShare.API}
            GetAndShare={GetAndShare}
            phone={phone}
            setPhone={setPhone}
            setAnswerInfoHandler={setAnswerInfoHandler}
            saveAnswerInfoToAPI={saveAnswerInfoToAPI}
            showPanel={showPanel}
            getTraitId={getTraitId}
          />
        </BBlockWrapper>
        <CBlockWrapper>
          <CBlock summary={summary} analysis={analysis} befit={befit} />
        </CBlockWrapper>
      </Wrapper>
      <Panel
        showPanel={showPanel}
        setShowPanel={setShowPanel}
        content={panelContent}
      />
    </BG>
  )
}
const BG = styled.div`
  background-color: #000;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  @media (max-width: 1200px) {
    justify-content: start;
    align-items: start;
    height: auto;
  }
`

const BGWrapper = styled.div`
  position: absolute;
  width: 100%;
  opacity: 0.2;
  border-radius: 50%;
  overflow: hidden;
  transform: scale(1.2);
  animation: showBG 1s forwards;
  .filter {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    width: 100%;
    height: 100vh;
    backdrop-filter: blur(10px);
  }
  @media (max-width: 1200px) {
    position: fixed;
    animation: none;
    width: 100%;
    padding-top: 0%;
    height: 100vh;
    border-radius: 0;
    .filter {
      top: 50%;
      left: 0;
      height: 100vh;
    }
  }
  @keyframes showBG {
    0% {
      width: 0%;
      height: 0vh;
      opacity: 0;
      border-radius: 50%;
    }
  }
`

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  height: var(--vh);
  display: flex;
  max-width: 1600px;
  max-height: 800px;
  padding: 40px 40px 40px 40px;
  margin: 0 auto;
  gap: 20px;

  @media (max-width: 1200px) {
    flex-direction: column;
    max-height: 100%;
    height: auto;
    max-width: 800px;
  }
  @media (max-width: 768px) {
    max-width: 450px;
    padding: 20px;
  }
  @keyframes fade {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fadeup {
    0% {
      transform: translate(0, 300px);
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fadedown {
    0% {
      transform: translate(0, -300px);
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fadeleft {
    0% {
      transform: translate(-300px, 0);
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes faderight {
    0% {
      transform: translate(300px, 0);
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes zoomin {
    0% {
      transform: translate(-50%, -50%) scale(0.1);
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
`
const ABlockWrapper = styled.div`
  flex: 1.8;
  display: flex;
  .RoleWrapper {
    opacity: 0;
    animation: fade 0.6s forwards ease-out 1s;
  }
  .title {
    opacity: 0;
    animation: fade 1s forwards 1.5s ease-in-out;
  }
  .titleResult {
    opacity: 0;
    animation: fadeleft 1s forwards 2s ease-in-out;
  }
  .SayingWrapper {
    opacity: 0;
    animation: fade 1s forwards 0.5s ease-in-out;
  }
  .CoolBox {
    opacity: 0;
    animation: fadeup 1s forwards 2.5s ease-in-out;
  }
`
const BBlockWrapper = styled.div`
  flex: 2.3;
  display: flex;
  position: relative;
  @media (max-width: 1200px) {
    order: 3;
  }
  .RoleWrapper {
    opacity: 0;
    animation: zoomin 0.6s forwards ease-out 1s;
    will-change: transform;
  }
  .BottomWrapper {
    opacity: 0;
    animation: fade 1s forwards 5s ease-in-out;
    @media (max-width: 1200px) {
      opacity: 0;
      animation: fade 1s forwards 4s ease-in-out;
    }
  }
`
const CBlockWrapper = styled.div`
  flex: 2;
  display: flex;
  .RoleSummary {
    opacity: 0;
    animation: faderight 1s forwards 3s ease-in-out;
  }
  .Befit {
    opacity: 0;
    animation: fadeup 1s forwards 3.5s ease-in-out;
  }
`

const CircleWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0px;
  width: 100%;

  .c1 {
    animation: circle 1s forwards ease 2;
  }
  .c2 {
    animation: circle 1s forwards ease 0.2s 1;
  }
  .c3 {
    animation: circle 1s forwards ease 0.5s 1;
  }
`
